import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEmployeeMasterList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/employeeMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            commit('setEmployeeMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})         
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
    
}

export const loadEmployeeStatement = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    
    axios.post('/employeeMaster/statement.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEmployeeStatement', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchEmployeeProductionStageList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/employeeMaster/fetchAllocatedProductionStage.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEmployeeProductionStageList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchWorkOrderEmployeeList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/employeeMaster/workOrderEmployeeList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEmployeeMasterList', {response: res.data.response, total: 0})                 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally(() => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchEmployeeMasterData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/employeeMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setEmployeeMasterData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {employee_id: payload.id, copy: payload.copy})     
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetEmployeeMasterData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitEmployeeMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
    
        if(res.data.status) {
            dispatch('fetchEmployeeMasterData', { id: payload.id })
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const generateNewPassword = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeMaster/generateNewPassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Password generated successfully!!!'});
            commit('setEmployeeMasterUserPassword', res.data.password)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteEmployeeMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchEmployeeMasterList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/employee/actions.js